import { c as _c } from "react/compiler-runtime";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import styles from "@website/widget/banner-medium/banner-medium.module.scss";
import { BannerMediumItem } from "@website/widget/banner-medium/components";
import { BannerSlidePropertiesType } from "@website/widget/banner-slide/banner-slide.types";
import { FC, useState } from "react";
export const BannerSlide: FC<BannerSlidePropertiesType> = properties => {
  const $ = _c(9);
  const {
    list,
    isLoading: t0,
    className,
    width,
    height: t1,
    shouldRedirectUsingJs,
    noFollow
  } = properties;
  const isLoading = t0 === undefined ? false : t0;
  const height = t1 === undefined ? 300 : t1;
  const [selectedTab, setSelectedTab] = useState(0);
  let t2;
  if ($[0] !== className || $[1] !== height || $[2] !== isLoading || $[3] !== list || $[4] !== noFollow || $[5] !== selectedTab || $[6] !== shouldRedirectUsingJs || $[7] !== width) {
    t2 = isLoading ? <Skeleton height={height} /> : list?.length > 0 ? <CarouselV2 itemClass={`${className} ${styles.item}`} keyCarousel={`BannerMedium-${list[selectedTab]?.bannerId}`} list={list.map((item, index) => {
      const itemIndex = index + 1;
      const itemKey = item.bannerId ?? item.imageId ?? item.linkTo ?? itemIndex;
      return <BannerMediumItem shouldRedirectUsingJs={shouldRedirectUsingJs} noFollow={noFollow} key={itemKey} {...{
        ...item,
        id: itemIndex,
        height: height || item.height,
        width: width || item.width,
        onClick: () => setSelectedTab(itemIndex)
      }} />;
    })} mode="free" options={{
      slides: {
        perView: "auto",
        spacing: 16
      }
    }} /> : null;
    $[0] = className;
    $[1] = height;
    $[2] = isLoading;
    $[3] = list;
    $[4] = noFollow;
    $[5] = selectedTab;
    $[6] = shouldRedirectUsingJs;
    $[7] = width;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};